import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import UtilsUrl from "../../../utils/UtilsUrl";
import UtilsFormule from "../../../utils/UtilsFormule";
import PackService from "../../../services/PackService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import Swal from "sweetalert2";
const DataTableProductsPack = ({ listProduits }) => {
  const navigate = useNavigate();

  const [products, setProducts] = useState(listProduits);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const handleDetails = (row) => {
    console.log("View details for:", row.id);
    localStorage.setItem("packId", row.id)
    navigate('/PackDetails')
    // Add logic to view details
  };

  const handleDelete = async (row) => {
    console.log("Delete row:", row);

    // Display SweetAlert2 confirmation modal
    const result = await Swal.fire({
      title: "Êtes-vous sûr ?",
      text: "Cette action supprimera le pack. Voulez-vous continuer ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimer !",
      cancelButtonText: "Annuler",
    });

    // If the user confirms deletion
    if (result.isConfirmed) {
      try {
        // Call delete API or logic
        await PackService.DeletePack(getCurrentUserId(), row.id);

        // Display success message
        Swal.fire("Supprimé !", "Le pack a été supprimé avec succès.", "success");
      } catch (error) {
        // Display error message
        Swal.fire(
          "Erreur !",
          "Une erreur s'est produite lors de la suppression.",
          "error"
        );
      }
    } else {
      // If user cancels, show a message or simply return
      console.log("L'utilisateur a annulé la suppression.");
    }
  };

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };



  function dateFormatter(cell, row) {
    return (
      <span>
        {UtilsFormule.formatDate(row.creationDate)}
      </span>
    );

  }

  function isFreeFormatter(cell, row) {
    if (row.isFree === 0) {
      return (
        <span>
          Gratuité / Testeur
        </span>
      );
    } else if (row.isFree === 1) {
      return (<span>
        Non gratuit
      </span>)
    }


  }
  function libelleFormatter(cell, row) {
    console.log("row", row);
    return (
      <span>
        {row.refPack}
      </span>
    );

  }

  // function buttonDeleteFormatter(cell, row) {
  //   if (row.isDeleted === 0) {
  //     return (
  //       <span>
  //         <button
  //           className="btn btn-danger"
  //           onClick={(e) => {
  //             let deletedAndRestoreModel;

  //             deletedAndRestoreModel = {
  //               idProduct: cell,
  //               isDeleted: 1,
  //             };

  //             dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
  //             setOpenInfoAlert(true);

  //             setInfoAlertText("Element supprimé avec succée ");

  //             setProducts(products.filter((dept) => dept.id !== cell));
  //           }}
  //         >
  //           <h6>
  //             <small>
  //               {" "}
  //               <i class="fas fa-trash"></i>
  //             </small>
  //           </h6>
  //         </button>
  //       </span>
  //     );
  //   } else if (row.isDeleted === 1) {
  //     return (
  //       <span>
  //         <button
  //           className="btn btn-info"
  //           onClick={(e) => {
  //             let deletedAndRestoreModel;

  //             deletedAndRestoreModel = {
  //               idProduct: cell,
  //               isDeleted: 0,
  //             };

  //             dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
  //             setInfoAlertText("Element restauré avec succée ");
  //             setOpenInfoAlert(true);

  //             setProducts(products.filter((dept) => dept.id !== cell));
  //           }}
  //         >
  //           <h6>
  //             <small>
  //               <RestoreFromTrashRoundedIcon />
  //             </small>
  //           </h6>
  //         </button>
  //       </span>
  //     );
  //   }
  // }

  const columns = [

    {
      dataField: "refPack",
      text: "Réference",
      // formatter: libelleFormatter,
      headerStyle: () => {
        return { width: "20%" };
      },
    },

    {
      dataField: "namePack",
      text: "Libellé",
      // formatter: libelleFormatter,
      headerStyle: () => {
        return { width: "20%" };
      },
    },


    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      formatter: dateFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "isFree",
      text: "Type",
      align: "center",
      headerAlign: "center",
      formatter: isFreeFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },

    {
      dataField: "price",
      text: "Prix",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "Action",
      text: "Actions",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" }; // Adjust width as needed
      },
      formatter: (cell, row) => {
        return (
          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
            <button
              onClick={() => handleDetails(row)}
              className="btn btn-info btn-sm"
              title="Details"
            >
              <i className="fas fa-eye"></i>
            </button>
            <button
              onClick={() => handleDelete(row)}
              className="btn btn-danger btn-sm"
              title="Delete"
            >
              <i className="fas fa-trash-alt"></i>
            </button>
          </div>
        );
      },
    },




  ];

  // const specificities=(row)=>{

  //   if(row.specificities.length>0){
  //     return (
  //       <table
  //         class="table table-striped table-bordered table-sm"
  //         cellspacing="0"
  //         width="100%"
  //       >
  //         <thead>
  //           <tr className="text-center">
  //             <th>Libellé</th>
  //               <th>Valeur</th>
  //             <th>Description</th>

  //           </tr>
  //         </thead>
  //         <tbody>
  //           {row.specificities &&
  //             row.specificities.map((element, i) => (
  //               <tr key={i}>
  //                 <td>{element.name}</td>

  //                 <td>{element.value}</td>

  //                 <td className="text-center">
  //                   {element.description}
  //                 </td>
  //               </tr>
  //             ))}
  //         </tbody>
  //       </table>
  //     ); 
  //   }

  // }
  const expandRow = {
    renderer: (row) => (
      <div>
        <p>{`Famille de produits: ${row.familyName}`}</p>
        <p>{`Sous-Famille de produits: ${row.subFamilyName}`}</p>
        <p>{`Catégorie de produits: ${row.categoryName}`}</p>
        <p>{`Description: ${row.description}`}</p>
        {/* {specificities(row)} */}

        {/* <p>
          expandRow.renderer callback will pass the origin row object to you
        </p> */}
      </div>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <>
      <ToolkitProvider
        keyField="id"
        data={listProduits}
        columns={columns}
        onTableChange={handleTableChange}
        exportCSV
        search
      >
        {(props) => (
          <div>
            <div className="row ml-0">
              <div>
                <SearchBar
                  {...props.searchProps}
                  className="custome-search-field"
                  style={{ color: "black" }}
                  placeholder="Chercher"
                ></SearchBar>
              </div>
              <div className="ml-auto mr-0">
                <MyExportCSV {...props.csvProps}></MyExportCSV>
              </div>
            </div>
            {/* <div className="row"> */}
            <BootstrapTable
              {...props.baseProps}
              pagination={paginationFactory(options)}
              striped
              hover
              condensed
            // expandRow={expandRow}
            />
            {/* </div> */}
          </div>
        )}
      </ToolkitProvider>


      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
export default DataTableProductsPack;